<template>
    <div
        v-if="organization !== null && company !== null"
        class="container-fluid p-companies-show">
        <div class="mb-3">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="card">
                        <div class="card-header">法人詳細</div>
                        <div class="card-body pt-2">
                            <h5 class="vc-head-detail">基本情報</h5>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">法人番号</div>
                                        <div class="vc-detail__value">{{ `#${company.id}` }}</div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">法人名</div>
                                        <div class="vc-detail__value">
                                            <span v-if="company.name === null || company.name === ''" class="text-muted">-</span>
                                            <span v-else>{{ company.name }}</span><!--
                                         --><span v-if="company.name_kana !== null" class="small text-muted">（{{ company.name_kana }}）</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">代表者名</div>
                                        <div class="vc-detail__value">
                                            <span v-if="company.representative === null || company.representative === ''" class="text-muted">-</span>
                                            <span v-else>{{ company.representative }}</span><!--
                                         --><span v-if="company.representative_kana !== null" class="small text-muted">（{{ company.representative_kana }}）</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">担当者</div>
                                        <div class="vc-detail__value">
                                            <div v-if="company.authorizer">
                                                {{ `#${company.authorizer.id} ${company.authorizer.full_name}` }}
                                            </div>
                                            <div v-else>
                                                <span class="text-muted">未設定</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">住所</div>
                                        <div class="vc-detail__value">
                                            <span v-if="company.address === null || company.address === ''" class="text-muted">-</span>
                                            <span v-else>{{ company.address }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">電話番号</div>
                                        <div class="vc-detail__value">
                                            <span v-if="company.tel === null || company.tel === ''" class="text-muted">-</span>
                                            <span v-else>{{ company.tel }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">会員数</div>
                                        <div class="vc-detail__value">{{ company.user_count.toString() }}</div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">ステータス</div>
                                        <div
                                            class="vc-detail__value"
                                            :class="{ 'text-danger font-weight-bold' : company.flg_paused }">
                                            {{ company.flg_paused ? '利用停止中' : '利用中' }}
                                        </div>
                                    </div>
                                </div>
                            </div>

<!--                            <div class="row">-->
<!--                                <div class="col-12 col-md-6">-->
<!--                                    <div class="vc-detail">-->
<!--                                        <div class="vc-detail__title">健康管理パッケージ</div>-->
<!--                                        <div-->
<!--                                            class="vc-detail__value">-->
<!--                                            {{ company.is_health_package ? '利用する' : '利用しない' }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-12 col-md-6">-->
<!--                                    <div class="vc-detail">-->
<!--                                        <div class="vc-detail__title">担当者への{{ $locale.consultation_host }}詳細表示</div>-->
<!--                                        <div-->
<!--                                            class="vc-detail__value">-->
<!--                                            {{ company.is_viewable_authorizer ? '表示する' : '表示しない' }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

                            <div class="row">
                                <div class="col-12">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">メモ</div>
                                        <div class="vc-detail__value" style="white-space: pre-wrap;">
                                            <div v-if="company.authorizer_memo === null || company.authorizer_memo === ''" class="text-muted">-</div>
                                            <div v-else>{{ company.authorizer_memo }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="vc-detail">
                                        <div class="vc-detail__title">管理用タグ</div>
                                        <div class="vc-detail__value d-flex" style="white-space: pre-wrap;">
                                            <div v-if="filteredGroupAuthorizerTags.length < 1" class="text-muted">-</div>
                                            <div
                                                v-for="tag in filteredGroupAuthorizerTags"
                                                class="d-flex align-baseline">
                                                <div class="groupAuthorizerTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <b-button
                                    variant="yokumiru-ash"
                                    class="ml-2 mr-2 text-muted"
                                    :href="previousUrl !== null ? previousUrl : '/organization'">
                                    戻る
                                </b-button>
                                <b-button
                                    variant="yokumiru-blue"
                                    class="ml-2 mr-2"
                                    @click="showModalAuthorizerEditChildGroup">
                                    編集
                                </b-button>
<!--                                <b-button-->
<!--                                    variant="danger"-->
<!--                                    class="ml-2 mr-2"-->
<!--                                    @click="showModalAdminCompanyDelete">-->
<!--                                    削除-->
<!--                                </b-button>-->
<!--                                <b-button-->
<!--                                    v-if="!company.flg_paused"-->
<!--                                    variant="outline-danger"-->
<!--                                    class="ml-2 mr-2"-->
<!--                                    @click="showModalAdminCompanyPause">-->
<!--                                    利用停止-->
<!--                                </b-button>-->
<!--                                <b-button-->
<!--                                    v-if="company.flg_paused"-->
<!--                                    variant="yokumiru-outline-blue"-->
<!--                                    class="ml-2 mr-2"-->
<!--                                    @click="showModalAdminCompanyResume">-->
<!--                                    利用再開-->
<!--                                </b-button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-card no-body>
            <b-tabs card>
                <b-tab :title="`${$locale.patient}一覧`">
                    <b-container fluid>
                        <authorizer-group-users
                            :timezone="timezone"
                            :parent-group="organization"
                            :group="company"
                            can-add
                            can-authorizer>
                        </authorizer-group-users>
                    </b-container>
                </b-tab>
                <b-tab :title="`${$locale.consultation_host}一覧`">
                    <b-container fluid>
                        <authorizer-group-consultations
                            :timezone="timezone"
                            :parent-group="organization"
                            :group="company"
                            :medical-courses="medicalCourses">
                        </authorizer-group-consultations>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-card>

        <authorizer-child-group-edit-modal
            :parent-group="organization">
        </authorizer-child-group-edit-modal>

<!--        <user-delete-group-modal/>-->
<!--        <user-pause-group-modal/>-->
<!--        <user-resume-group-modal/>-->
    </div>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        props: {
            timezone: {
                type: String,
                default: 'Asia/Tokyo',
            },
            dataOrganization: {
                type: Object,
                required: true,
            },
            dataCompany: {
                type: Object,
                required: true,
            },
            userCategories: {
                type: Array,
                required: true,
            },
            medicalCourses: {
                type: Array,
                required: true,
            },
            previousUrl: {
                type: String|null,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                organization: null,
                company: null,
            }
        },

        computed: {
            /**
             * 管理用タグ（担当者用）
             * @return {array}
             */
            filteredGroupAuthorizerTags: function () {
                if (!this.company || !this.organization || this.company.group_authorizer_tags.length < 1) {
                    return []
                }
                return this.company.group_authorizer_tags.filter((tag) => tag.authorizer_id === this.organization.authorizer_id)
            },
        },

        created: function () {
            this.organization = {...this.dataOrganization}
            this.company = {...this.dataCompany}
            bus.$on('fetch-child-group', this.fetchChildGroup)
            bus.$on('group-users-store', this.fetchChildGroup)
        },

        beforeDestroy: function () {
            bus.$off('fetch-child-group')
            bus.$off('group-users-store')
        },

        methods: {
            /**
             * 子グループ詳細取得
             */
            fetchChildGroup: function () {
                const endpoint = constants.user.groups.endpoint.base

                axios.get(`${endpoint}/${this.organization.id}/groups/${this.company.id}`)
                    .then(({data}) => {
                        this.company = data.data
                    })
            },

            /**
             * グループ編集モーダル表示
             */
            showModalAuthorizerEditChildGroup: function () {
                bus.$emit('open-modal-authorizer-child-group-edit', this.company)
            },

            // /**
            //  * グループ削除モーダル表示
            //  */
            // showModalAdminCompanyDelete: function () {
            //     bus.$emit('open-modal-user-delete-group', this.company)
            // },
            //
            // /**
            //  * グループ利用停止モーダル表示
            //  */
            // showModalAdminCompanyPause: function () {
            //     bus.$emit('open-modal-user-pause-group', this.company)
            // },
            //
            // /**
            //  * グループ利用再開モーダル表示
            //  */
            // showModalAdminCompanyResume: function () {
            //     bus.$emit('open-modal-user-resume-group', this.company)
            // },
            //
            // /**
            //  * 会員詳細モーダル表示
            //  *
            //  * @param {number} userId
            //  */
            // showModalAdminUserProfile: function (userId) {
            //     bus.$emit('open-modal-user-user-profile', userId)
            // },
        },
    }
</script>

<style lang="scss" scoped>
.groupAuthorizerTag {
    padding: 3px 5px;
    margin-right: 5px;
    color: #5834b4;
    font-size: .85em;
    background-color: #f4f2f8;
    border: 1px solid #e2dced;
    border-radius: 2px;
}
</style>

<style lang="scss">
.vc-head-detail {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0 5px;
}

.vc-detail {
    margin: 8px 0;

    .vc-detail__title {
        color: #6c757d;
    }

    .vc-detail__value {
        padding: 4px 0 3px;
        border-bottom: 1px solid #dfdfdf;
    }
}
</style>
